/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.userBalanceTransfer.internal

import features.userBalanceTransfer.models.TransferRequestModel
import features.userBalanceTransfer.models.TransferResponseModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class BalanceTransferServiceImpl : BalanceTransferService {

    private val balanceTransferRequest = BalanceTransferRequest()

    override suspend fun transfer(
        overrideHeaders : Map<String, String>?,
        transferRequest: TransferRequestModel    ): Result<TransferResponseModel> {
        return balanceTransferRequest.transfer(
            overrideHeaders = overrideHeaders,
            transferRequest = transferRequest        ).toModel()
    }
}
